"use client";

import { useEffect } from 'react';
import { Provider as JotaiProvider } from 'jotai';
import { Toaster } from 'react-hot-toast';
import { AuthEffects } from '../auth-effects';
// import { ClientAnalyticsBlocker } from '../client-analytics-blocker';
import { DeviceIDProvider } from '@/components/providers/device-id-provider';
import { ModalProvider } from '@/components/providers/modal-provider';
import { QueryProvider } from '@/components/providers/query-provider';
import WalletProvider from '@/components/providers/wallet-provider';
import { TrackingEffects } from '../tracking-effects';
import NotifyBanner from '@/features/notifications/components/notify-banner';
import { ChangeCheckPoller } from '@/components/change-check-poller';
import { PollingIntervalController } from '@/components/polling-interval-controller';
import { syncSEOChannelToSessionStorage, syncApkSeoDownloadUrlToSessionStorage } from '@/utils/seo';

export function AppProviders({ children }: { children: React.ReactNode; }) {
  useEffect(() => {
    syncSEOChannelToSessionStorage();
    syncApkSeoDownloadUrlToSessionStorage();
  }, []);

  return (
    <>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 2700,
          icon: null,
          className: 'flex items-center text-secondary text-ss font-medium px-4 py-[15px] bg-tag rounded-[8px]',
          style: {
            boxShadow: 'rgba(0, 0, 0, 0.3) 0px 0px 4px',
          },
        }}
        containerStyle={{
          top: '48%',
        }}
        containerClassName="toast-container"
      />
      <JotaiProvider>
        <DeviceIDProvider>
          <QueryProvider>
            {/* <ClientAnalyticsBlocker /> */}
            <WalletProvider>
              <ModalProvider>
                {children}
                <AuthEffects />
                <TrackingEffects />
                {/* 站内信横幅显示组件 */}
                <NotifyBanner />
                {/* 统一轮询组件 */}
                <ChangeCheckPoller />
                <PollingIntervalController />
              </ModalProvider>
            </WalletProvider>
          </QueryProvider>
        </DeviceIDProvider>
      </JotaiProvider>
    </>
  );
}
